import { Component, Input } from '@angular/core';
import { ThreadFilterService } from '../../../core/services/thread-filter.service';
import { TicketDetailsComponent } from '../../ticket-details.component';
import { DetailedTicketDTO } from '../../../core/models/dto/detailed-ticket.dto';
import { TranslateModule } from '@ngx-translate/core';
import { MessageThreadElementType } from '@sb-tools/typescript/enums/message-thread-element-type.enum';

@Component({
    selector: 'app-thread-expander',
    templateUrl: './thread-expander.component.html',
    styleUrls: ['./thread-expander.component.scss'],
    imports: [TranslateModule],
})
export class ThreadExpanderComponent {
    @Input() defaultCount? = 2;
    @Input() parent: TicketDetailsComponent;
    @Input() ticket: DetailedTicketDTO;

    threadFilterService = ThreadFilterService;

    get repliesCount(): number {
        return (this.ticket?.messageThread || []).filter((message) => {
            return message.type !== MessageThreadElementType.sessionAuthentication;
        }).length;
    }

    get hiddenRepliesCount(): number {
        return Math.max(
            this.repliesCount - this.defaultCount - this.threadFilterService.collapseOptions.takeReplies,
            0,
        );
    }

    loadMoreReplies(isForBigThread?) {
        const collapsibleRepliesCount = this.repliesCount;

        if (isForBigThread) {
            if (collapsibleRepliesCount - this.defaultCount >= 50) {
                this.threadFilterService.collapseOptions.takeReplies =
                    this.threadFilterService.collapseOptions.takeReplies + 50;
            } else {
                this.threadFilterService.collapseOptions.takeReplies =
                    collapsibleRepliesCount - this.threadFilterService.collapseOptions.takeReplies - this.defaultCount;
            }
        } else {
            this.threadFilterService.collapseOptions.isCollapsed = false;
            this.threadFilterService.collapseOptions.takeReplies = collapsibleRepliesCount - this.defaultCount;
        }
        this.threadFilterService.refreshUpdateStamp();
    }
}
